import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "@ppb/tbd-store/state/ApplicationState.types";
import { createViewItemThemeByURNSelector } from "@ppb/tbd-store/state/layout/views/view-selectors";

/**
 * Resolves the `isHighlighted` flag a migrated card would otherwise have received through props.
 *
 * `theme` is a catalogue *edge* property, so it describes a placement rather than a card, and it
 * reaches a legacy card as a prop through `GenericView` -> `ViewItem` -> `Card`. `renderCard` passes
 * migrated cards only `{ urn, visible }`, so a host wrapper has to read the placement itself.
 */
export function useViewItemIsHighlighted(urn: string): boolean {
  const getViewItemTheme = useMemo(() => createViewItemThemeByURNSelector(), []);
  const theme = useSelector((state: ApplicationState) => getViewItemTheme(state, urn));

  return theme === "HIGHLIGHTED";
}
